import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { scrollToForm } from "@/App";

const ClosingCta = () => {
  return (
    <section
      data-testid="closing-cta-section"
      className="bg-gdark py-14 md:py-[70px]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-serif font-bold text-white tracking-tight text-3xl md:text-4xl leading-tight">
            Ready to see what you qualify for?
          </h2>
          <p className="mt-2 italic text-glight text-lg">
            Cleaner energy, brighter tomorrow.
          </p>
        </motion.div>
        <motion.button
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.1 }}
          onClick={scrollToForm}
          data-testid="closing-cta-button"
          className="shrink-0 inline-flex items-center gap-2 bg-amber text-navy-deep font-bold text-lg px-8 py-4 rounded-lg hover:-translate-y-0.5 transition-transform duration-200"
        >
          See My Price
          <ArrowRight className="w-5 h-5" />
        </motion.button>
      </div>
    </section>
  );
};

export default ClosingCta;
